export default {
    state: { 
        orgStage:null,
        orgIndustry:null,
        companyIndustry:null,
        companyRound:null,
        companyInvestmentDate:null,
        filter:{
            orgRelatiohshipDeepthIds:null,
            companyRelationshipDeepthIds:null,
        }
    },
}


// WEBPACK FOOTER //
// ./src/common/store.js